module.exports = __webpack_public_path__ + "img/ic_item_jk_click.5e0cef8a.png";